import React from 'react';
import ReactDOM from 'react-dom';
import './pages/shared.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
import NetworkStatus from './components/NetworkStatus';
import { initSentry } from './utils/sentry';
import { installGlobalErrorHandlers } from './common/util/errorLogger';

// 开发环境屏蔽 React error overlay 对 API 错误的拦截
if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const msg = args[0]?.toString?.() || '';
    if (msg.includes('Uncaught runtime errors') || msg.includes('Request failed with status code')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}

installGlobalErrorHandlers();
initSentry();

ReactDOM.render(
  <ErrorBoundary>
    <NetworkStatus />
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);

reportWebVitals();
